define('shared/initializer/form/newHouseAdapters/mixins/LoggedInUserRedirectable',[
    'shared/lib/RSVP',
    './Loginable'
], function(
    RSVP,
    Loginable
){
    function Ctor() { }

    Ctor.prototype.doPageLoad = function () {
        return Loginable.redirect({
            doNotTryOldHouse: true
        });
    };
});
